// extracted by mini-css-extract-plugin
export var currencyInput = "_ms-1";
export var currencySymbol = "_ms-0";